import React from 'react';
import ReactDOM from 'react-dom';
import NotificationSystem from 'react-notification-system';

class NotificationComponent extends React.Component {
    notify(title, message, level, autoDismiss = 5) {
        this.refs.notificationSystem.addNotification({
            title,
            message,
            level,
            autoDismiss,
        });
    }

    render() {
        return (<NotificationSystem ref="notificationSystem" />);
    }
}

class Notification {
    success(message, title) {
        const notification = ReactDOM.render(React.createElement(NotificationComponent),
            document.getElementById('notification'));
        notification.notify(title, message, 'success');
    }

    error(message, title) {
        const notification = ReactDOM.render(React.createElement(NotificationComponent),
            document.getElementById('notification'));
        notification.notify(title, message, 'error', 7);
    }

    warning(message, title) {
        const notification = ReactDOM.render(React.createElement(NotificationComponent),
            document.getElementById('notification'));
        notification.notify(title, message, 'warning');
    }
}

const notification = new Notification();
export default notification;
